import { Badge } from "@/modern/components/ui/badge";
import { Loader2 } from "lucide-react";
import type { AuditItem } from "../utils/editorUtils";

interface EditorAuditFooterProps {
  items: AuditItem[];
  isSaving?: boolean;
}

export function EditorAuditFooter({ items, isSaving }: EditorAuditFooterProps) {
  return (
    <div className="flex flex-1 flex-wrap items-center gap-2 text-xs text-muted-foreground">
      {items.length ? (
        items.map((item) => (
          <div key={item.key} className="flex items-center gap-1.5 rounded-full border  bg-background/60 px-2.5 py-1">
            <Badge variant="outline" className="rounded-full border-transparent bg-muted/50 px-2 py-0 text-[0.6rem] font-semibold uppercase tracking-wide text-muted-foreground">
              {item.label}
            </Badge>
            <span className="text-xs font-medium text-foreground/90">{item.value}</span>
          </div>
        ))
      ) : (
        <span className="text-sm text-muted-foreground">No timeline activity yet.</span>
      )}

      {isSaving && (
        <div className="flex items-center gap-1.5 text-muted-foreground/70 text-xs">
          Saving Changes... <Loader2 className="w-3.5 h-3.5 animate-spin" />
        </div>
      )}
    </div>
  );
}
